import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { montNameMap } from "../../../../../../../config/config";
export const getCreatedOnMesage = (dateStr: string) => {
  dayjs.extend(relativeTime);
  const currentDate = dayjs();
  const prevDate = dayjs(dateStr);
  if (currentDate.diff(prevDate, "day") > 1) {
    return `${
      montNameMap[`${prevDate.month()}`]
    } ${prevDate.date()},${prevDate.year()}`;
  }
  return dayjs(dateStr).fromNow();
};
